import type { PropsWithChildren } from "react";

import { TextTestID } from "@/constants/TestID";
import { Text } from "@/ui/core";
import EquipLogoInline from "@/ui/core/EquipLogoInline";
import { VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface LoginScreenContentProps extends PropsWithChildren<ViewWithTestID> {
  subtitle: string;
  title: string;
}

const LoginScreenContent = ({
  children,
  subtitle,
  testID,
  title,
}: LoginScreenContentProps) => {
  return (
    <VStack flex={1} gap={24} justifyContent="center">
      <EquipLogoInline />
      <VStack gap={12}>
        <Text
          color={ColorToken.Primary90Variant}
          testID={joinTestIDs(testID, TextTestID.Title)}
          variant="h2"
        >
          {title}
        </Text>
        <Text
          color={ColorToken.Primary90Variant}
          testID={joinTestIDs(testID, TextTestID.Description)}
          variant="body"
        >
          {subtitle}
        </Text>
      </VStack>
      {children}
    </VStack>
  );
};

export default LoginScreenContent;
